import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Small floating pill that flips a game between immersive (fullscreen) and
 * windowed. Shared by the Academic Skill Games; anchors to the bottom-end
 * corner of the game shell (opposite the "Select Game" button).
 */
@Component({
  selector: 'app-fullscreen-toggle',
  templateUrl: './fullscreen-toggle.component.html',
  styleUrls: ['./fullscreen-toggle.component.scss']
})
export class FullscreenToggleComponent {
  @Input() isFullscreen = true;
  @Input() currLang: any = 'en';
  @Output() toggle = new EventEmitter<void>();
}
